import { Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { HeaderComponent } from './components/header/header.component';
import { AppCheckService } from './services/app-check.service';

/** Routes without app-header (embed iframe, dedicated auth layout). */
const NO_GLOBAL_HEADER_PREFIXES = ['/embed', '/login'];

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CookieConsentComponent, HeaderComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private readonly router = inject(Router);

  private readonly url = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(e => e.urlAfterRedirects),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  /** True when the routed page must not show the global header (embed). */
  readonly hideGlobalHeader = computed(() => {
    const path = this.url().split('?')[0];
    return NO_GLOBAL_HEADER_PREFIXES.some(
      prefix => path === prefix || path.startsWith(`${prefix}/`),
    );
  });

  constructor() {
    inject(AppCheckService).warmToken();
  }
}
